module.exports = __webpack_public_path__ + "static/img/logoshorizontal.027260b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/festival2025/logoshorizontal.png
// module id = 454
// module chunks = 11